/**
 * PopupBaseMap - Base map for popup windows using the user's chosen basemap
 *
 * Reads the active_base_map setting synced from the main window via
 * PopupSettingsProvider and renders the matching tile layer.
 * Falls back to OSM if the basemap type isn't supported in popups (e.g. S57, WMS).
 */
import React from 'react';
import { OSMTileLayer, BlueTileLayer } from '@ais-ui/react-openlayers';
import { useSharedSettings } from '../Settings/SharedSettingsContext';
import { getOsmUrlHeadersFromSettings } from '../utils/getOsmUrlHeadersFromSettings';

const CARTO_DARK_URL =
  'https://a.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png';

export const PopupBaseMap: React.FC = () => {
  const { settings } = useSharedSettings();
  const activeBaseMapId = settings['ribbonPlugin.settings']?.active_base_map;

  if (activeBaseMapId === 'blue') {
    return <BlueTileLayer color="#aad3df" />;
  }

  if (activeBaseMapId === 'carto-dark') {
    return <OSMTileLayer key="carto-dark" url={CARTO_DARK_URL} />;
  }

  const osmBaseUrl = settings['assetDisplay.mapengine']?.osmBaseUrl;

  // Only use custom OSM URL if one is actually configured
  if (osmBaseUrl) {
    const { url: osmUrl, headers: osmHeaders } =
      getOsmUrlHeadersFromSettings(settings);
    return <OSMTileLayer key="osm-custom" url={osmUrl} headers={osmHeaders} />;
  }

  return <OSMTileLayer key="osm" />;
};
